import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import IconLogo from 'components/icons/IconLogo';

const styles = theme => ({
  root: {
    height: 36,
    width: 106,
    marginBottom: 24,
    [theme.breakpoints.up('sm')]: {
      marginBottom: 30,
    },
  },
});

const AccountLogo = ({ classes }) => (
  <IconLogo
    color="dark"
    className={classes.root}
  />
);

AccountLogo.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(AccountLogo);



// WEBPACK FOOTER //
// ./src/components/account/AccountLogo/AccountLogo.js